import * as logos from '../../../img/vendor/connections';
import { ConnectionTypeName } from '../../connections/connection.models';

export function connectionIconUrlByType(connectionType: ConnectionTypeName): string {
  return logos[connectionType];
}
